import React from 'react';
import { Link } from '@/components/LocaleLink';
import SEO from '@/components/SEO';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import useScrollReveal from '@/hooks/useScrollReveal';
import { useLanguage } from '@/contexts/language/LanguageContext';
import { bookACallCopy } from '@/contexts/language/translations/pages/bookACall';

const BookACall = () => {
  useScrollReveal();
  const { language } = useLanguage();
  const c = bookACallCopy[language];

  return (
    <div className="flex flex-col min-h-screen">
      <SEO
        title={c.seoTitle}
        description={c.seoDescription}
        canonical="/book-a-call"
      />
      <Navigation />
      <main className="index-page flex-1">

        {/* Hero */}
        <section className="relative pt-28 pb-16 md:pt-36 md:pb-20 overflow-hidden bg-white">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#FFF7EC] rounded-full filter blur-3xl opacity-60" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#E0E7FF] rounded-full filter blur-3xl opacity-40" />

          <div className="container-custom relative z-10 reveal">
            <div className="max-w-3xl mx-auto text-center">
              <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF6B35] mb-5">{c.eyebrow}</p>
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-[#2A1E47] mb-6 leading-[1.08]">
                {c.title}
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
                {c.subtitle}
              </p>
            </div>
          </div>
        </section>

        {/* Calendar booking */}
        <section className="pb-20 md:pb-28 px-7 md:px-10">
          <div className="container-custom reveal">
            <div className="max-w-3xl mx-auto">
              {/* Calendar booking */}
              <div className="rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
                <div className="px-8 py-5 bg-[#2A1E47] flex items-center gap-3">
                  <svg className="w-5 h-5 text-[#FF6B35] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
                  </svg>
                  <h2 className="text-lg font-bold text-white">{c.calendarTitle}</h2>
                </div>
                <iframe
                  src="https://calendar.app.google/d1zdx9SNCNmx37gz8"
                  title={c.calendarFrameTitle}
                  className="w-full h-[720px] border-0 block"
                />
              </div>

              <p className="text-center text-sm text-muted-foreground mt-8">
                {c.messagePrompt}{' '}
                <Link to="/tell-me-more" className="text-[#FF6B35] font-semibold hover:underline">
                  {c.messageLink}
                </Link>
              </p>
            </div>
          </div>
        </section>

      </main>
      <Footer />
    </div>
  );
};

export default BookACall;
